import { render, staticRenderFns } from "./FeaturedYoutubeVideo.vue?vue&type=template&id=1013a359&scoped=true&"
import script from "./FeaturedYoutubeVideo.vue?vue&type=script&lang=ts&"
export * from "./FeaturedYoutubeVideo.vue?vue&type=script&lang=ts&"
import style0 from "./FeaturedYoutubeVideo.vue?vue&type=style&index=0&id=1013a359&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013a359",
  null
  
)

export default component.exports